import React from "react";
import GestionNotifications from "../../GestionNotifications/GestionNotifications";

function HotelNotificationPage() {
  return <GestionNotifications />;
}

export default HotelNotificationPage;
